// extracted by mini-css-extract-plugin
module.exports = {"button":"Authorizaton_button__2czJg","buttonLogout":"Authorizaton_buttonLogout__3j-aO"};